import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import { UserRole } from "model/user/userRole";
import * as z from "zod";
import { TFunction } from "i18next";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";

const UserRegisterSchema = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.number(),
  }),
});

export interface MutateUserRegisterParams {
  emailAddress: string;
  role: UserRole;
  languageId: number;
  timeZone: string;
}

export const mutateUserRegister = async (values: MutateUserRegisterParams) => {
  const response = await makeMutation(ApiEndpoints.userRegister(), values, false, 'POST', userRegisterErrorCodes);
  return UserRegisterSchema.parse(response);
};

export const userRegisterErrorCodes = {
  ...generalErrorCodes,
  EMAIL_ALREADY_REGISTERED: {
    code: "EMAIL_ALREADY_REGISTERED",
    translation: (t: TFunction) => t("signUp.EMAIL_ALREADY_REGISTERED"),
  },
  PHONE_ALREADY_REGISTERED: {
    code: "PHONE_ALREADY_REGISTERED",
    translation: (t: TFunction) => t("signUp.PHONE_ALREADY_REGISTERED"),
  },
};
